import { Link } from "@caspeco/casper-ui-library";

function EmailLink({
    email,
    textDecoration,
    color,
}: {
    email: string;
    textDecoration?: string;
    color?: string;
}) {
    return (
        <Link href={`mailto:${email}`} textDecoration={textDecoration} color={color}>
            {email}
        </Link>
    );
}

export default EmailLink;
